import React, { useState, useEffect } from 'react';
import clientsQueries from '../../../../requests/queries/ClientsQueries';

const ClientsManagement = () => {

    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedClients, setSelectedClients] = useState([]);
    const [debouncedSearch, setDebouncedSearch] = useState('');

    const fetchClients = async () => {
        if(!search) {
            const res = await clientsQueries.getAll();
            setClients(res.data.clients);
        } else {
            const res = await clientsQueries.findBySearch(search);
            setClients(res.data.clients);
        }
    }

    const handleSelectAllClients = () => {
        if(selectedClients.length === clients.length) {
            setSelectedClients([]);
        } else {
            setSelectedClients(clients.map((client) => client.id));
        }
    };

    const handleSelectClient = (clientId) => {
        if (selectedClients.includes(clientId)) {
          setSelectedClients(selectedClients.filter(id => id !== clientId));
        } else {
          setSelectedClients([...selectedClients, clientId]);
        }
    };

    useEffect(() => {
        fetchClients();
    }, [debouncedSearch]);

    // Debounce effect pour la recherche
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000);

        return () => clearTimeout(timer);
    }, [search]);

    return (
      <div className="clients-section">
        <div className="section-header">
          <h2>Gestion des Clients</h2>
          <div className="search-box">
            <i className="bi bi-search"></i>
            <input value={search} onChange={(e) => setSearch(e.target.value)} type="text" placeholder="Search for a client..." />
          </div>
          <button className="btn btn-primary" onClick={async ()=>{
            await clientsQueries.sendPassword(selectedClients);
            setSelectedClients([]);
            setSearch('');
          }}>Envoyer le mot de passe</button>
        </div>
  
        <div className="clients-list">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th><input type="checkbox" onChange={handleSelectAllClients} checked={selectedClients.length === clients.length} /></th>
                  <th>ID</th>
                  <th>Email</th>
                  <th>Date d'inscription</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                {
                    clients.map((client) => (
                        <tr key={client.id}>
                            <td><input checked={selectedClients.includes(client.id)} type="checkbox" onChange={() => handleSelectClient(client.id)} /></td>
                            <td>{client.id}</td>
                            <td>{client.email}</td>
                            <td>{new Date(client.created_at).toLocaleDateString()}</td>
                            <td><span className={client.last_code_id_used ? "badge bg-success" : "badge bg-danger"}>{client.last_code_id_used ? 'Actif' : 'Inactif'}</span></td>
                        </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  export default ClientsManagement;